angular
	.module('servicepro.clienteditor', [
		'ngResource',
		'ng-sortable',
		'ui.bootstrap'
	]);
